<template>
    <div>
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <b-container>
            <b-row>
                <b-col cols="12" class="text-content">
                    <div class="mt-4 mb-5">
                        <h2 class="mb-4 text-info-title text-center" v-html="content.name1"></h2>
                        <div v-html="content.text1"></div>
                    </div>
                    <div class="mt-4 mb-5" v-if="typeof content.gallery1 === 'object' && content.gallery1.length">
                        <swiper class="swiper mb-3 product-gallery" ref="gallery" :options="swiperGallery">
                            <swiper-slide v-for="(item, index) in content.gallery1" :key="`item${index}`">
                                <div class="aspect-ratio ratio-16-9">
                                    <div class="aspect-content">
                                        <img :src="imageUrl(item.image)" :alt="item.description" :title="item.description"
                                            class="object-fit-contain">
                                    </div>
                                </div>
                            </swiper-slide>
                            <div class="swiper-pagination" slot="pagination"></div>
                            <div class="swiper-button-prev mx-2" slot="button-prev">
                                <svg width="30px" height="30px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M14 5l-7 7 7 7"/>
                                </svg>
                            </div>
                            <div class="swiper-button-next mx-2" slot="button-next">
                                <svg width="30px" height="30px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M10 5l7 7-7 7"/>
                                </svg>
                            </div>
                        </swiper>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
    import Breadcrumb from '~/components/Breadcrumb';
    import utils from "~/mixins/utils";

    export default {
        mixins: [
            utils
        ],
        head() {
            return {
                title: this.page_title,
            }
        },
        data() {
            return {
                content: {},
                page_title: '',
                swiperGallery: {
                    lazy: true,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }
        },
        computed: {
            breadcrumb() {
                let breadcrumb = [
                    {
                        name: 'Home',
                        link: '/'
                    },
                    {
                        name: this.page_title,
                        link: null
                    }
                ];
                return breadcrumb;
            },
        },
        components: {
            Breadcrumb
        },
        async fetch() {
            await this.$axios.$get(`api/v1/cms/?page_id=1`).then((res) => {
                if (res.status === 'success') {
                    this.content = res.data
                    this.page_title = res.data.name1 || res.title
                }
            }).catch((e) => {
                console.error(e)
            })
        }
    }
</script>
